export const driver = {
  authorizedVehicles: "已授权设备",
  certExpireTime: "驾照有效期至",
  driverName: "司机姓名",
  faceID: "面部识别",
  faceIDPhoto: "面部识别照片",
  nfcCardId: "NFC卡号",
  permitted: "允许",
  workXConnectAppCloudUserAccess: "CWorkX Connect App 云端用户访问",
  certPhoto: "驾照",
  driverPhoto: "司机照片",
  certExpire: "驾照到期",
};
